
import { useModal } from "@/useModal";
import { computed, defineComponent, markRaw } from "vue";
import SignUp from "./SignUp.vue";
import { useStore } from "@/store";

export default defineComponent({
  setup() {
    const modal = useModal();
    const store = useStore();

    const auth = computed(() => {
      return !!store.getState().authors.currentUserId;
    });

    const signIn = () => {};
    const signUp = () => {
      modal.component.value = markRaw(SignUp);
      modal.showModal();
    };
    const signOut = () => {};

    return {
      component: modal.component,
      signIn,
      signUp,
      signOut,
      auth,
      hide: () => {
        modal.hideModal();
      },
    };
  },
  components: { SignUp },
});
